import RestAPI from './components/Common/restApi';

export const getEnvironmentVariables = () =>
  RestAPI.get('/internal/environment_variables.json').then((response) => {
    const environmentVariables = response.data;
    Object.keys(environmentVariables).map((key) => (window[key] = environmentVariables[key]));
  });
